import { Alert, Box, Button } from '@mui/material';
import * as Sentry from '@sentry/react';
import { Component, type ErrorInfo, type ReactNode } from 'react';

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<{ children: ReactNode }, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    Sentry.captureException(error, { extra: { componentStack: info.componentStack } });
  }

  override render(): ReactNode {
    if (!this.state.error) return this.props.children;
    return (
      <Box sx={{ p: 4, maxWidth: 600, mx: 'auto', mt: 6 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          Something went wrong.
        </Alert>
        <Button variant="outlined" onClick={() => this.setState({ error: null })}>
          Try again
        </Button>
      </Box>
    );
  }
}
